import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import EMTLevel from "../../components/emtLevel";
import MyLink from "../../components/myLink";
import Caution from "../../components/caution";
import Note from "../../components/note";
import { AdultBasicShockTable, AdultAdvancedShockTable, AdultParamedicShockTable } from "../../data/tables/shockTable";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Note id="note-1" alignment="left" mdxType="Note">
  Any patient with signs, symptoms, and history suggesting inadequate
  tissue perfusion should be considered tbe in shock. 
  <br /><br />
  Make every effort to determine and treat the underlying cause.
  Regardless of etiology, shock patients should be transported
  immediately tthe nearest appropriate facility for definitive care .
    </Note>
    <EMTLevel level="basic" mdxType="EMTLevel">
  <ul>
    <li>
      <MyLink to="/sections/1/1.0-routine-patient-care" mdxType="MyLink">
        1.0 Routine Patient Care
      </MyLink>
    </li>
    <li>
      Keep the patient supine.
    </li>
    <li>
      Prevent heat loss by covering with warm blankets if available and if the patient is not febrile.
    </li>
    <li>
      Physiological signs:
      <ul>
       <li>Altered mental status.</li>
       <li>Radial pulse cannot be palpated.</li>
       <li>Systolic blood pressure less than 100 mmHg.</li>
      </ul>
    </li>
  </ul>
  <AdultBasicShockTable mdxType="AdultBasicShockTable" />
    </EMTLevel>
    <EMTLevel level="advanced" mdxType="EMTLevel">
  <AdultAdvancedShockTable mdxType="AdultAdvancedShockTable" />
    </EMTLevel>
    <EMTLevel level="paramedic" mdxType="EMTLevel">
  <ul>
    <li>
      Consider fluid administration.
    </li>
    <li>
      If signs and symptoms of hypoperfusion persist or symptoms worsen,
      regardless of etiology, consider norepinephrine, epinephrine or dopamine
      administration in the absence of hemorrhagic shock, with medical control
      approval.
    </li>
  </ul>
    </EMTLevel>
    <EMTLevel level="paramedic" medControl={true} mdxType="EMTLevel">
  <AdultParamedicShockTable mdxType="AdultParamedicShockTable" />
    </EMTLevel>
    <Note id="note-2" alignment="left" mdxType="Note">
  <strong style={{
        "display": "block",
        "margin": "0 0 0.75rem 0.25rem"
      }}>
    Etiology of Shock:
  </strong>
  <ul>
    <li>
      <strong>Cardiogenic Shock: </strong> History of cardiac surgery,
      rhythm disturbances, or post cardiac arrest. Assess for acute MI
      and pulmonary edema.
      <ul>
        <li>
          Signs & Symptoms of cardiogenic shock: chest pain, shortness of
          breath, crackles, JVD, hypotension, tachycardia, diaphoresis.
        </li>
      </ul>
    </li>
    <li>
      <strong>Distributive Shock: </strong> Anaphylaxis (see 2.2
      Allergic Reaction/Anaphylaxis), neurogenic shock, sepsis. Assess
      for fever and signs of infection.
      <ul>
        <li>
          Signs & Symptoms of neurogenic shock: sensory and/or motor
          loss, hypotension, bradycardia versus normal heart-rate, warm,
          dry skin.
        </li>
      </ul>
    </li>
    <li>
      <strong>Hypovolemic Shock: </strong> Dehydration, volume loss, or
      hemorrhagic shock.
      <ul>
        <li>
          Signs & Symptoms of hypovolemic shock: tachycardia, tachypnea,
          hypotension, diaphoresis, cool skin, pallor, flat neck veins.
        </li>
      </ul>
    </li>
    <li>
      <strong>Obstructive Shock: </strong> Consider tension
      pneumothorax, pulmonary embolism, and cardiac tamponade.
      <ul>
        <li>
          Signs and symptoms of tension pneumothorax: asymmetric or
          absent unilateral breath sounds, respiratory distress or
          hypoxia, signs of shock including tachycardia and hypotension,
          JVD, possible tracheal deviation above the sternal notch (late
          sign).
        </li>
      </ul>
    </li>
  </ul>
    </Note>
    <Note id="note-3" alignment="left" mdxType="Note">
  <strong style={{
        "marginBottom": "0.5rem",
        "display": "block"
      }}>
    For patients with uncontrolled hemorrhagic or penetrating torso injuries:
  </strong>
  <ul>
    <li>
      Restrict IV fluids. Delaying aggressive fluid resuscitation until
      operative intervention may improve the outcome.
    </li>
    <li>
      Patients should be reassessed frequently, with special attention
      given to the lung examination to ensure volume overload does not
      occur.
    </li>
    <li>
      Several mechanisms for worse outcomes associated with IV fluid
      administration have been suggested, including dislodgement of clot
      formation, dilution of clotting factors, and acceleration of
      hemorrhage caused by elevated blood pressure.
    </li>
  </ul>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      